export const ID_LIST_STORE_KEY = 'id_list'
export const ACCOUNT_STORE_KEY = 'account'
export const LIST_STORE_KEY = 'list'
export const USER_STORE_KEY = 'user'
export const ACCOUNT_OPTIONS_KEY = 'account_options'
export const USER_OPTIONS_KEY = 'user_options'
export const LOGIN_TYPE_KEY = 'login_type'
export const LISTS_COUNT_STORE_KEY = 'lists_count'
export const ACCOUNT_STORE_DATA_RETENTION = 'account_data_retention'
export const LANG = 'lang'

export const LOGIN_TYPE_WEBLOGIN = 0
export const LOGIN_TYPE_ADM = 1
export const LOGIN_TYPE_ADMLIMITED = 2
export const LOGIN_TYPE_RESELLER = 3

export { STORE_KEY_LANG, STORE_KEY_USER_LANG } from 'mailup-react-helpers'
